import loadable from '@loadable/component';
import landingPageQuery from './query.graphql';

const ShopOfTheYearLandingPage = loadable(() =>
  import(
    /* webpackChunkName: "shop-of-the-year" */
    './components/landing-page'
  )
);

ShopOfTheYearLandingPage.graphQL = landingPageQuery;

ShopOfTheYearLandingPage.variables = ({ section }) => {
  return { section };
};

export { ShopOfTheYearLandingPage };
